// eslint-disable-next-line complexity
const serializePractitionerActivity = form => ({
  worked_hours: form.hoursWorked ?? null,
  missed_appointments: form.missedAppointments ?? null,
  new_patients: form.newPatients ?? null,
  proposed_treatment_plans: form.treatmentPlansProposed ?? null,
  placed_crowns: form.crownsPlaced ?? null,
  active_ortho_patients: form.activeOrthoPatients ?? null,
  scheduled_appointments: form.scheduledAppointments ?? null,
  treated_patients: form.patientsTreated ?? null,
  emergency_count: form.emergencies ?? null,
  accepted_treatment_plans: form.treatmentPlansAccepted ?? null,
  placed_implants: form.implantsPlaced ?? null,
  revenue: form.revenue ?? null,
  siren: form.siren?.toString() ?? null,
  period: form.period?.toString() ?? null
});

const serializeAllPractitionersActivities = (practitionerActivity, siren, period) => {
  return Object.entries(practitionerActivity).map(([practitionerId, activityForm]) => ({
    ...serializePractitionerActivity(activityForm),
    practitioner_id: practitionerId,
    siren,
    period
  }));
};

export {serializePractitionerActivity, serializeAllPractitionersActivities};
